import { Navigate } from "react-router-dom";
import { Leaf } from "lucide-react";
import { useAuth } from "./AuthContext";

const Splash = () => (
  <div className="min-h-screen bg-[#081C15] flex items-center justify-center" data-testid="auth-loading-splash">
    <Leaf className="h-8 w-8 text-[#EAA332] animate-pulse" />
  </div>
);

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === undefined) return <Splash />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

export const AdminRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === undefined) return <Splash />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/hub" replace />;
  return children;
};
